import { useState } from 'react';
import AdminsTable from './adminsTable';
import Button from 'components/button';
import AdminForm from './adminForm';

const Admins = () => {
  const [isFormVisible, setIsFormVisible] = useState(false);

  const handleToggleForm = () => {
    setIsFormVisible((prevState) => !prevState);
  };

  return (
    <div>
      <Button onClick={handleToggleForm} extraClasses="ml-auto mr-4 mb-4">
        {isFormVisible ? 'Back' : 'Create Admin'}
      </Button>
      {isFormVisible ? <AdminForm type="Add" /> : <AdminsTable />}
    </div>
  );
};

export default Admins;
